import o from"styled-components";import{theme as r}from"../../../theme.js";const i=o.div`
  cursor: pointer;
  display: grid;
  grid-template-columns: max-content 20px;
  grid-column-gap: ${r.spacing*2}px;
  align-items: center;
  padding: ${r.spacing*2}px;
  border-radius: ${r.radius}px;
  &:hover {
    background-color: ${r.colors.gray[100]};
  }
`,e=o.div`
  width: 20px;
  height: 20px;
  transform: ${({open:t})=>t?"rotate(180deg)":"rotate(0deg)"};
  color: ${r.colors.gray[900]};
  > svg {
    width: 20px;
    height: 20px;
    > g, path {
      fill: ${r.colors.gray[900]};
    }
  }
`;export{i as FiltersButton,e as Icon};
